<template>
  <div>
    <div class="contentArea">
      <!-- {{page}} -->
      <div v-if="page.type === 'table'">
        <AgGrid />
      </div>
        <div v-if="page.type === 'setting'">
        <settingRole/>
      </div>
    </div>
  </div>
</template>

<script>
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import Banner from "./elements/banner/Banner.vue"
import settingRole from "./elements/settingRole/settingRole"

import { mapGetters } from "vuex";

export default {
  components: {
    AgGrid,
    Banner,
    settingRole
  },
  data() {
    return {
      language:null,
      radios2:'primary',
    }
  },
  computed: {
    ...mapGetters({
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive",
      page: "general/page",
    }),
  },

  async mounted() {
    await this.$store.dispatch("general/getPage_3");
    //await this.$store.dispatch("general/getPage"); 

  
    // this.$store.dispatch("general/getTab", this.nowSlug);
    // this.$store.dispatch("general/getTable",( this.tabActive.path||this.nowSlug));
    // eslint-disable-next-line no-console
    // console.log("page", this.page);
  },
  watch: {
    // tabActive(newValue) {
    //   this.$store.dispatch("general/getTable", newValue.path);
    // }
  },
};
</script>
